// Utilitários para validação e formatação de faixas IPv4 / CIDR

// Converte texto digitado em lista de CIDRs (aceita vírgula, ponto-e-vírgula ou espaço)
export function separarCidrs(texto) {
  return String(texto ?? "")
    .split(/[\s,;]+/)
    .map((parte) => parte.trim())
    .filter(Boolean);
}

// Valida se o texto é um CIDR IPv4 válido (ex: 100.64.0.0/16 ou IP único)
export function cidrValido(texto) {
  const [endereco, prefixo, ...resto] = String(texto ?? "").split("/");
  if (resto.length > 0) return false;

  const octetos = String(endereco).split(".");
  if (octetos.length !== 4) return false;
  if (!octetos.every((o) => /^\d{1,3}$/.test(o) && Number(o) <= 255)) {
    return false;
  }

  if (prefixo === undefined) return true;
  const bits = Number(prefixo);
  return /^\d{1,2}$/.test(prefixo) && bits >= 0 && bits <= 32;
}

// Retorna os itens inválidos da lista (array vazio se todos forem válidos)
export function cidrsInvalidos(texto) {
  return separarCidrs(texto).filter((cidr) => !cidrValido(cidr));
}
